import VueRouter, { RouteConfig } from 'vue-router'
import { ClazzStatsQuery } from '../models/clazzStat'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const ClazzStat = () => import('../views/ClazzStat.vue')
const ClazzDetails = () => import('../views/ClazzDetails.vue')
const ClazzManagement = () => import('../views/ClazzManagement.vue')
const ClazzStudentEdit = () => import('../views/ClazzStudentEdit.vue')
const ClazzStatsExport = () => import('../views/ClazzStatsExport.vue')
const ClazzStudentRecords = () => import('../views/ClazzStudentRecords.vue')
const ClazzStudentDetails = () => import('../views/ClazzStudentDetails.vue')
const ClazzTeacherAssign = () => import('../views/ClazzTeacherAssign.vue')
const SportsTeamAdd = () => import('../views/SportsTeamAdd.vue')

export const clazzDetailsRoute: RouteConfig = {
  path: '/clazz-details',
  name: 'clazz_details',
  component: ClazzDetails,
  props: (route) => ({
    ...route.query,
    ...route.params,
    id: Number(route.query.id),
  }),
  meta: {
    title: '班级详情',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const clazzManagementRoute: RouteConfig = {
  path: '/clazz-management',
  name: 'clazz_management',
  component: ClazzManagement,
  props: (route) => ({
    ...route.query,
    ...route.params,
    id: route.query.id,
    isExcutive: JSON.parse(route.query.isExcutive as any),
  }),
  meta: {
    title: '班级管理',
  },
}

export const clazzStudentEditRoute: RouteConfig = {
  path: '/clazz-student-edit',
  name: 'clazz_student_edit',
  component: ClazzStudentEdit,
  props: (route) => ({ ...route.query, ...route.params, clazzId: Number(route.query.clazzId) }),
  meta: {
    title: '编辑学生信息',
  },
}

export const clazzStatsExportRoute: RouteConfig = {
  path: '/clazz-stats-export',
  name: 'clazz_stats_export',
  component: ClazzStatsExport,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
    query: JSON.parse(route.query.query as string),
  }),
  meta: {
    title: '导出数据',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const clazzStudentDetailsRoute: RouteConfig = {
  path: '/clazz-student-details',
  name: 'clazz_student_details',
  component: ClazzStudentDetails,
  props: (route) => ({ ...route.query, ...route.params, id: Number(route.query.id) }),
  meta: {
    title: '学生详情',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const sportsTeamAddRoute: RouteConfig = {
  path: '/sports-team-add',
  name: 'sports_team_add',
  component: SportsTeamAdd,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '创建校队',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const clazzTeacherAssignRoute: RouteConfig = {
  path: '/clazz-teacher-assign',
  name: 'clazz_teacher_assign',
  component: ClazzTeacherAssign,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级执教教师',
  },
}

const RClazz: RouteConfig[] = [
  clazzDetailsRoute,
  clazzManagementRoute,
  clazzStudentEditRoute,
  clazzStatsExportRoute,
  clazzStudentDetailsRoute,
  sportsTeamAddRoute,
  clazzTeacherAssignRoute,
  {
    path: '/clazz-stat',
    name: 'clazz_stat',
    component: ClazzStat,
    props: (route) => ({ ...route.query, ...route.params, id: Number(route.query.id) }),
    meta: {
      title: '班级统计',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
  },
  {
    path: '/clazz-student-records',
    name: 'clazz_student_records',
    component: ClazzStudentRecords,
    props: (route) => ({ ...route.query, ...route.params, user_id: Number(route.query.user_id) }),
  },
]

export default RClazz

export function navigateToClazzDetails(
  router: VueRouter,
  clazzId: number,
  studentsAmount: string,
  imgUrl: string,
  category: 'clazzes' | 'sports_team',
  type: 'push' | 'replace' = 'push'
) {
  router[type]({
    name: clazzDetailsRoute.name,
    query: {
      id: `${clazzId}`,
      studentsAmount,
      imgUrl,
      category,
    },
  })
}

export function navigateToClazzManagement(
  router: VueRouter,
  clazzId: number,
  category: 'clazzes' | 'teach' | 'sports_team',
  isExcutive = true
) {
  router.push({
    name: clazzManagementRoute.name,
    query: { id: `${clazzId}`, category, isExcutive: JSON.stringify(isExcutive) },
  })
}

export function navigateToClazzStudentEdit(router: VueRouter, clazzId: number, userId: string, clazzName = '') {
  router.push({ name: clazzStudentEditRoute.name, query: { clazzId: `${clazzId}`, userId, clazzName } })
}

export function redirectToClazzStudentEdit(router: VueRouter, clazzId: number, userId: string, clazzName = '') {
  router.replace({ name: clazzStudentEditRoute.name, query: { clazzId: `${clazzId}`, userId, clazzName } })
}

export function navigateToClazzStatsExport(
  router: VueRouter,
  type: string,
  query: ClazzStatsQuery,
  clazzId: number,
  studentId: string
) {
  router.push({
    name: clazzStatsExportRoute.name,
    query: { type, query: JSON.stringify(query), clazzId: `${clazzId}`, studentId },
  })
}

export function navigateToClazzStudentDetails(router: VueRouter, clazzId: number, studentId: string) {
  router.push({ name: clazzStudentDetailsRoute.name, query: { id: `${clazzId}`, studentId } })
}

export function navigateToClazzTeacherAssign(router: VueRouter, clazzId: number | string) {
  router.push({ name: clazzTeacherAssignRoute.name, query: { id: `${clazzId}` } })
}
